// hooks/usePaymentHistory.js

import { useEffect, useState } from "react";
import { deleteApi, getApi, postApi, putApi } from "../../services/api";
import { toast } from "react-toastify";

export default function usePaymentHistory() {
	const [searchTerm, setSearchTerm] = useState("");
	const [isModalVisible, setIsModalVisible] = useState(false);
	const [modalType, setModalType] = useState("");
	const [selectedPayment, setSelectedPayment] = useState(null);
	const [payments, setPayments] = useState([]);

	useEffect(() => {
		const fetchTeachers = async () => {
			try {
				const paymentDatas = await getApi(`/payment`);

				if (paymentDatas && !paymentDatas.error) {
					setPayments(
						paymentDatas.map((payment) => ({
							student: payment?.userId?.fullName,
							studentId: payment?.userId?._id,
							status: payment.status,
							paymentDate: new Date(
								payment.paymentDate
							).toLocaleDateString(),
							originalPaymentDate: payment.paymentDate,
							course: payment?.classroomId?.courseId?.name,
							courseId: payment?.classroomId?.courseId?._id,
							classroomId: payment?.classroomId?._id,
							transactionNo: payment?.transactionNo,
							amount: payment.amount,
							id: payment._id,
						}))
					); // Set fetched payments
				}
			} catch (error) {
				toast.error(`Error fetching teachers: ${error.message}`);
			}
		};

		fetchTeachers();
	}, []);
	const filteredPayments = payments.filter(
		(payment) =>
			payment.student &&
			payment.student.toLowerCase().includes(searchTerm.toLowerCase())
	);
	console.log(filteredPayments);

	const showModal = (type, payment) => {
		setModalType(type);
		setSelectedPayment(payment);
		setIsModalVisible(true);
	};

	const handleModalConfirm = async () => {
		// Handle the confirmation action for the modal (e.g., Add, Edit, Delete)
		setIsModalVisible(false);
	};
	const handleSwitch = async (value, switchedPayment) => {
		const payment = await putApi(`/payment/${switchedPayment.id}`, {
			status: value ? "Completed" : "Deleted",
		});
		if (payment && value) {
			await postApi("/enrollment", {
				classroomId: switchedPayment.classroomId,
				userId: switchedPayment.studentId,
				paymentStatus: "active",
			});
		} else if (payment && !value) {
			await deleteApi("/enrollment", {
				userId: switchedPayment.studentId,
				classroomId: switchedPayment.classroomId,
			});
		}
		const paymentData = {
			student: payment?.userId?.fullName,
			studentId: payment?.userId?._id,
			status: payment.status,
			paymentDate: new Date(payment.paymentDate).toLocaleDateString(),
			originalPaymentDate: payment.paymentDate,
			course: payment?.classroomId?.courseId?.name,
			courseId: payment?.classroomId?.courseId?._id,
			classroomId: payment?.classroomId?._id,
			transactionNo: payment?.transactionNo,
			amount: payment.amount,
			id: payment._id,
		};
		setPayments((prev) => {
			return prev.map((pay) =>
				pay.id !== payment._id ? pay : paymentData
			);
		});
		setSelectedPayment(paymentData);
	};

	const handleModalCancel = () => {
		setIsModalVisible(false);
	};

	return {
		searchTerm,
		setSearchTerm,
		isModalVisible,
		modalType,
		selectedPayment,
		showModal,
		handleModalConfirm,
		handleModalCancel,
		filteredPayments,
		handleSwitch,
	};
}
